import { get, post, postFile } from "../Service/ApiConfig";
import {
  PostFilterReportEndPoint,
  PostTransactionReportByFiltersEndPoint,
  ReportEndPoint,
} from "../Service/Endpoints/ApiEndPoints";

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const SUPPORTED_EXPORT_FILE_TYPES = ["pdf", "xlsx"];

const normalizeOptionalString = (value) => {
  if (value === undefined || value === null) {
    return null;
  }

  const trimmedValue = String(value).trim();
  return trimmedValue.length > 0 ? trimmedValue : null;
};

const normalizeOptionalStringArray = (value) => {
  if (!Array.isArray(value)) {
    return null;
  }

  const normalizedValues = value
    .map((item) => normalizeOptionalString(item))
    .filter(Boolean);

  return normalizedValues.length > 0 ? normalizedValues : null;
};

const normalizeOptionalDate = (value, fieldName) => {
  if (value === undefined || value === null || value === "") {
    return null;
  }

  if (typeof value !== "string" || !DATE_ONLY_REGEX.test(value)) {
    throw new Error(`Invalid ${fieldName}.`);
  }

  return value;
};

const normalizeFileType = (fileType) => {
  const normalizedFileType = fileType === "excel" ? "xlsx" : fileType;

  if (!SUPPORTED_EXPORT_FILE_TYPES.includes(normalizedFileType)) {
    throw new Error("Unsupported report export request.");
  }

  return normalizedFileType;
};

export const createReportExportPayload = ({
  reportName,
  fileType,
  startDate = null,
  endDate = null,
  doctors = null,
  column = null,
  searchString = null,
  providerId = null,
  selectedColumns = null,
} = {}) => {
  const normalizedReportName = normalizeOptionalString(reportName);

  if (!normalizedReportName) {
    throw new Error("Unsupported report export request.");
  }

  const payload = {
    reportName: normalizedReportName,
    fileType: normalizeFileType(fileType),
    startDate: normalizeOptionalDate(startDate, "startDate"),
    endDate: normalizeOptionalDate(endDate, "endDate"),
    doctors: normalizeOptionalString(doctors),
    column: normalizeOptionalString(column),
    searchString: normalizeOptionalString(searchString),
    providerId: normalizeOptionalString(providerId),
  };

  const normalizedSelectedColumns =
    normalizeOptionalStringArray(selectedColumns);

  if (normalizedSelectedColumns) {
    payload.selectedColumns = normalizedSelectedColumns;
  }

  return payload;
};

export const getReportDetails = async (reportNumber, reportType) => {
  const response = await get(ReportEndPoint.getReportDetails(reportType));

  return response;
};

export const postReportsByFilters = async (
  startDate,
  endDate,
  doctors,
  reportType,
) => {
  const payload = {
    startDate,
    endDate,
    doctors,
    reportType,
  };

  const response = await post(
    PostFilterReportEndPoint.getReportByFilter(),
    payload,
  );
  return response;
};

export const postTransactionReportByFilters = async (
  startDate,
  endDate,
  doctors,
  column,
  reportType,
) => {
  const payload = {
    startDate,
    endDate,
    doctors,
    column,
    reportType,
  };

  const response = await post(
    PostTransactionReportByFiltersEndPoint.getReportByFilter(),
    payload,
  );
  return response;
};

export const exportReportFile = async (payload) => {
  const response = await postFile(
    ReportEndPoint.exportReport(),
    createReportExportPayload(payload),
  );
  return response;
};
